import Fuse from 'fuse.js';
import axios from 'axios';
import { getPinInfoOriginal } from '@/help.filters';
const webapiUrl = window.webapiUrl;
export var AssistanceTypes;
(function (AssistanceTypes) {
    AssistanceTypes[AssistanceTypes["Charging"] = 1] = "Charging";
    AssistanceTypes[AssistanceTypes["Payment"] = 2] = "Payment";
})(AssistanceTypes || (AssistanceTypes = {}));
export var AssistanceMethods;
(function (AssistanceMethods) {
    AssistanceMethods[AssistanceMethods["FuelService"] = 1] = "FuelService";
    AssistanceMethods[AssistanceMethods["AssistanceButton"] = 2] = "AssistanceButton";
    AssistanceMethods[AssistanceMethods["AppOrWebsite"] = 3] = "AppOrWebsite";
})(AssistanceMethods || (AssistanceMethods = {}));
export var OpenSummaries;
(function (OpenSummaries) {
    OpenSummaries[OpenSummaries["Open"] = 1] = "Open";
    OpenSummaries[OpenSummaries["Closed"] = 2] = "Closed";
    OpenSummaries[OpenSummaries["OpeningSoon"] = 3] = "OpeningSoon";
    OpenSummaries[OpenSummaries["ClosingSoon"] = 4] = "ClosingSoon";
})(OpenSummaries || (OpenSummaries = {}));
export class SpsApiResult {
    constructor(apiData) {
        this.id = apiData.id;
        this.areaManagerId = apiData.areaManagerId;
        this.areaManagerFullName = apiData.areaManagerFullName;
        this.vehicleTypes = apiData.vehicleTypes == null ? [] : apiData.vehicleTypes; //N.B. version of TS in use 3.1.1 doesn't have "optional chaining" and TS doesn't seem to infer properly from Help.isNullOrUndef(), but according to Fenton here https://stackoverflow.com/questions/28975896/is-there-a-way-to-check-for-both-null-and-undefined this "juggling-check" does the job. N.B. prob want to update help method to see if can't get TS to infer properly
        this.filters = apiData.filters == null ? [] : apiData.filters;
        this.physicalTypes = apiData.physicalTypes == null ? [] : apiData.physicalTypes;
        this.paymentTypes = apiData.paymentTypes == null ? [] : apiData.paymentTypes;
        this.standardSpaces = apiData.standardSpaces;
        this.ecpSpaces = apiData.ecpSpaces;
        this.disabledSpaces = apiData.disabledSpaces;
        this.parentChildSpaces = apiData.parentChildSpaces;
        this.selected = apiData.selected;
        this.openSummary = apiData.openSummary;
        this.openingHours = apiData.openingHours;
        this.bookingUrl = apiData.bookingUrl;
        this.parkAccessDetail = apiData.parkAccessDetail;
        this.hasPm = apiData.hasPm;
        this.hasPmp = apiData.hasPmp;
        this.hasPa = apiData.hasPa;
        this.hasPaEv = apiData.hasPaEv;
        this.hasPmf = apiData.hasPmf;
        this.hasAmGo = apiData.hasAmGo;
        this.hasPAct = apiData.hasPAct;
        this.isSps = apiData.isSps;
        this.name = apiData.name;
        this.address = apiData.address;
        this.organisation = apiData.organisation;
        this.latitude = apiData.latitude;
        this.longitude = apiData.longitude;
        const x = getPinInfoOriginal(apiData);
        this.pinClass = x.pinClass;
        this.pinTitle = x.pinTitle; //TODO:TD check for uses of pinTitle and pinClass to make sure Result and ResultSelected templates etc ONLY use from data. not from the comp's OLD computed values now.
        if (apiData.id === 10161) //heathrow 
            this.searchName = "Heathrow Airport Meet and Greet LHR";
    }
}
export class AutoCompleteResult {
    constructor(name, address, organisation, latitude, longitude, pinClass, pinTitle, isSps) {
        this.name = name;
        this.address = address;
        this.organisation = organisation;
        this.latitude = latitude;
        this.longitude = longitude;
        this.pinClass = pinClass;
        this.pinTitle = pinTitle;
        this.isSps = isSps;
    }
}
export function mbToAutoCompleteResult(mb) {
    return new AutoCompleteResult(mb.text, removeUk(mb.place_name), "Location Result", //<i class="fad fa-map-pin"></i>
    mb.center[1], mb.center[0], //<i class="fa-duotone fa-solid fa-location-dot"></i>
    "fad fa-thumbtack", //"fad fa-map-marker-alt",//geoCode //<i class="fa-duotone fa-solid fa-map-pin"></i>   <font-awesome-icon :icon="['fad', 'map-pin']" />
    "Point of Interest / Location Result", //<i class="fa-solid fa-map-pin"></i> <font-awesome-icon :icon="['fas', 'map-pin']" />
    false //old <i class="fad fa-map-marker-alt"></i> https://fontawesome.com/v5/icons/map-marker-alt?f=classic&s=duotone
    ); //new <i class="fad fa-thumbtack"></i>  or <i class="fad fa-map-marked"></i>
}
export function getSpsCarParks() { return axios.get(webapiUrl).then(response => { return response.data; }); }
export function searchMbResultsAndSpsSites(mbApiResults, sitesFiltered, searchTerm) {
    const mbResults = mbApiResults.map(mb => mbToAutoCompleteResult(mb));
    const mbResultsAndSpsSites = [...sitesFiltered, ...mbResults];
    const fuseResults = new Fuse(mbResultsAndSpsSites, fuseOptions).search(searchTerm, { limit: 10 });
    //assessSearch(searchTerm, fuseResults)
    const fuseResultsRelevant = fuseResults;
    return fuseResultsRelevant.map(s => toAcResult(s.item));
}
function assessSearch(searchTerm, fuseResults) {
    console.log(`searchTerm ${searchTerm} gave:`);
    var resProj = fuseResults.map(coreRes);
    console.log("adas", resProj);
}
const coreRes = (i) => {
    return { n: i.item.name, s: i.score };
};
const maxResults = 10;
const fuseOptions = {
    includeScore: true,
    keys: [
        {
            name: 'searchName',
            weight: 50
        },
        'name',
        "address",
        "organisation"
    ]
};
function toAcResult(s) {
    if (s.isSps) {
        var x = getPinInfoOriginal(s); //TODO:MAP better to do this 1x when get api results from sps, and mod our ISpsApiResult to inc these two values... then never have to do again?
        return { ...s, ...x };
    }
    else
        return s;
}
const ukStringToMatch = ", United Kingdom";
function removeUk(mbAddress) {
    let respVal = mbAddress;
    let endsWithUk = mbAddress.trimEnd().endsWith(ukStringToMatch);
    if (endsWithUk) {
        var indexOfLastUk = mbAddress.lastIndexOf(ukStringToMatch);
        respVal = mbAddress.substring(0, indexOfLastUk);
    }
    return respVal;
}
